var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[(!_vm.isHideHeader)?_c('MyHeader'):_vm._e(),_c('keep-alive',{attrs:{"exclude":['Transcation', 'LikeDetail', 'Ask', 'Follow', 'Like', 'LikeMe']}},[(
        _vm.userData.singleStatus !== 6 && _vm.userData.singleStatus !== 7 ||
        _vm.$route.name === 'Home' ||
        _vm.$route.name === 'Messages' ||
        _vm.$route.name === 'Account' ||
        _vm.$route.name === 'Setting'
      )?_c('router-view'):_c('NotSingle')],1),(_vm.$root.isLoading)?_c('pageLoading'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }